<template>
  <Container>
    <v-flex justify-start>
      <v-card class="elevation-12">
        <v-toolbar dark tabs>
          <v-btn
            icon
            color="white"
            light
            v-on:click="$router.push('/driving_game')"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>{{ drivingGameList.category }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="showModalCreate()">
            <v-icon>add</v-icon>New Driving Game
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            v-if="!isLoadDrivingGame"
            :items="drivingGameList.driving_games"
            :headers="headers"
            :search="search"
            :rows-per-page-items="[20, 50, 100]"
          >
            <template v-slot:items="props">
              <td>
                <v-layout justify-center>{{ props.index + 1 }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>{{ props.item.title }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>
                  <v-chip color="primary" text-color="white">{{
                    formatDisplayCharacter(props.item.character)
                  }}</v-chip>
                </v-layout>
              </td>
              <td>
                <v-layout justify-center>
                  <v-chip color="primary" text-color="white">{{
                    formatDisplayTheme(props.item.theme)
                  }}</v-chip></v-layout
                >
              </td>
              <td>
                <v-layout justify-center>{{
                  props.item.correct_count
                }}</v-layout>
              </td>
              <td>
                <v-layout justify-center> {{ props.item.updated_at }}</v-layout>
              </td>
              <td>
                <v-layout justify-end>
                  <v-btn
                    icon
                    color="black"
                    @click="onClickAddHomePage(props.item._id)"
                  >
                    <v-icon>home</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="black"
                    v-on:click="onClickEdit(props.item._id)"
                  >
                    <v-icon color="white">edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="red"
                    v-on:click="onClickDelete(props.item._id)"
                  >
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-layout>
              </td>
            </template>
          </v-data-table>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-flex>
    <ModalCreateUpdate
      :isOpen="isShowModal"
      :isCreate="isCreate"
      @close="isShowModal = false"
    ></ModalCreateUpdate>
    <HomeDataAssign
      :isOpen="isAddHomepage"
      :gameData="selectedDrivingGame"
      :type="constantHomePage.GameType.PgGame"
      :typePgGame="constantHomePage.typePgGame.DrivingGame"
      @close="isAddHomepage = false"
    ></HomeDataAssign>
  </Container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Container from '../../../components/Container';
import { ModalCreateUpdate } from './components';
import rules from '../../../utils/ruleValidate';
import swal from 'sweetalert2';
import constants from './components/constants';
import HomeDataAssign from '../../HomePage/components/HomeDataAssign.vue';
import constantHomePage from '../../HomePage/constant';

export default {
  name: 'DrivingGame',
  components: {
    Container,
    ModalCreateUpdate,
    HomeDataAssign,
  },
  data() {
    return {
      constants,
      constantHomePage,
      search: '',
      headers: [
        {
          text: 'No.',
          value: 'no.',
          align: 'center',
          sortable: false,
        },
        {
          text: 'title',
          value: 'title',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Character',
          value: 'character',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Theme',
          value: 'theme',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Correct Count',
          value: 'correct_count',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Updated Date',
          value: 'updated_at',
          align: 'center',
          sortable: false,
        },
      ],
      isCreate: false,
      isShowModal: false,
      rules,
      isAddHomepage: false,
    };
  },
  async mounted() {
    const { id, game_list_id, category_id, sub_id } = this.$route.query;
    if (id) {
      await this.fetchDrivingGameList({ id });
      this.onClickEdit(id);
    } else if (game_list_id) {
      await this.fetchDrivingGameList({
        game_list_id,
      });
    } else if (category_id && sub_id) {
      await this.fetchDrivingGameList({
        category_id,
      });
      this.onClickEdit(sub_id);
    }
  },
  computed: {
    ...mapState({
      drivingGameStore: state => state.driving_game,
      drivingGameList: state => state.driving_game.drivingGameList,
      selectedDrivingGame: state => state.driving_game.selectedDrivingGame,
      isLoadDrivingGame: state => state.driving_game.isLoadDrivingGame,
      defaultCreate: state => state.driving_game.defaultCreate,
    }),
  },
  methods: {
    ...mapActions('driving_game', [
      'fetchDrivingGameList',
      'deleteDrivingGame',
      'setStateByKey',
    ]),
    setSelectedDrivingGame(id) {
      const [selectedData] = this.drivingGameList.driving_games.filter(
        ({ _id }) => _id == id,
      );
      if (selectedData) {
        this.setStateByKey({
          statekey: 'selectedDrivingGame',
          value: selectedData,
        });
      }
    },
    onClickAddHomePage(id) {
      this.setSelectedDrivingGame(id);
      this.isAddHomepage = true;
    },
    onClickEdit(id) {
      this.setSelectedDrivingGame(id);
      this.setStateByKey({
        statekey: 'updateDrivingGame',
        key: 'id',
        value: id,
      });
      this.isShowModal = true;
      this.isCreate = false;
    },
    onClickDelete(id) {
      swal
        .fire({
          titleText: 'Are you sure.',
          type: 'warning',
          showCancelButton: true,
        })
        .then(result => {
          if (result.value) {
            this.deleteDrivingGame(id);
          }
        });
    },
    formatDisplayTheme(value) {
      if (value >= 0) {
        switch (value) {
          case constants.theme.CITY:
            return 'CITY';
          case constants.theme.JUNGLE:
            return 'JUNGEL';
          case constants.theme.SPACE:
            return 'SPACE';
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    formatDisplayCharacter(value) {
      if (value >= 0) {
        switch (value) {
          case constants.character.MAXI:
            return 'MAXI';
          case constants.character.NANA:
            return 'NANA';
          case constants.character.NODDLE:
            return 'NODDLE';
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    showModalCreate() {
      this.isShowModal = true;
      this.isCreate = true;
      this.setStateByKey({
        statekey: 'createDrivingGame',
        value: this.defaultCreate,
      });
    },
  },
};
</script>

<style scoped>
.image_thumbnail {
  height: 90px;
  width: 90px;
  margin-top: 15px;
}
.content_img {
  height: 90px;
  width: 90px;
  border-radius: 8px;
}
</style>
